import { connect } from 'react-redux'
import AddToGroup from '../../../../add-to-group/add-to-group.container'
import { addPupilToGroup } from '../../../../../stores/profile/profile.actions'
import { getPupilGroupIds } from '../../../../../stores/profile/profile.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = dispatch => ({
  getGroups: (state, id) => getPupilGroupIds(state, id),
  action: (id, groupId) =>
    dispatch(
      addPupilToGroup(id, {
        student_account_id: id,
        group_id: groupId
      })
    ).catch(errorHandler)
})

export default connect(
  null,
  mapDispatchToProps
)(AddToGroup)
